import Immutable from 'immutable'
import { push } from 'react-router-redux'

import { basketOrderLoad } from 'actions/basket'
import { productsLoadCategories, productsLoadProducts, productsLoadStock } from 'actions/products'
import config from 'config/routes'
import * as orderV2 from 'routes/Menu/apis/orderV2'
import { getDiscountTrackingProperties } from 'routes/OrderConfirmation/experiments/GoustoAnytime/getDiscountTrackingProperties'
import logger from 'utils/logger'
import { getUserOrderRecipeUuIds } from 'utils/user'

import { actionTypes } from './actionTypes'
import recipeActions from './recipes'

const getRecipeItemPortionsByUuid = (order) => {
  const recipePortionsByUuid = {}

  order.get('recipeItems', Immutable.List()).forEach((recipe) => {
    const recipeId = recipe.get('recipeUuid') || recipe.get('id')
    recipePortionsByUuid[recipeId] = parseInt(recipe.get('quantity', 0), 10)
  })

  return recipePortionsByUuid
}

const getBasketOrderDetails = (order) => {
  const boxNumPortions = order.getIn(['box', 'numPortions'])
  const recipeItems = order.get('recipeItems')

  if (!Immutable.List.isList(recipeItems)) {
    return order
  }

  return order.set(
    'recipeItems',
    recipeItems.map((recipe) => recipe.set('quantity', boxNumPortions)),
  )
}

export const orderConfirmationRedirect = (orderId, orderAction) => (dispatch) => {
  const confirmationUrl = config.client.orderConfirmation.replace(':orderId', orderId)
  dispatch(push(orderAction ? `${confirmationUrl}?order_action=${orderAction}` : confirmationUrl))
}

export const orderDetails =
  (orderId, addRecipe, shouldTrackDiscount) =>
  async (dispatch, getState) => {
    try {
    dispatch(productsLoadCategories())
    dispatch(productsLoadStock())
    const { data: order } = await orderV2.fetchOrder(getState, orderId)
    const immutableOrderDetails = Immutable.fromJS(order)
    const orderRecipeUuIds = getUserOrderRecipeUuIds(immutableOrderDetails)
    const recipePortionsByUuid = getRecipeItemPortionsByUuid(immutableOrderDetails)
    const basketOrderDetails = getBasketOrderDetails(immutableOrderDetails)
    dispatch(recipeActions.recipesLoadFromMenuRecipesById(orderRecipeUuIds))
    await dispatch(
      productsLoadProducts(order.shippingAddress.postcode, order.period.id, {
        reload: true,
      }),
    )

    const isTransactionalOrder = order.orderType === 'transactional'
    const discount =
      shouldTrackDiscount && isTransactionalOrder
        ? getDiscountTrackingProperties(order.prices)
        : undefined

    dispatch(
      basketOrderLoad(
        orderId,
        (recipeId, view, recipeInfo, basketOrderId, isOrderRecipe) =>
          addRecipe(
            recipeId,
            view,
            recipeInfo,
            basketOrderId,
            isOrderRecipe,
            recipePortionsByUuid[recipeId],
          ),
        basketOrderDetails,
        discount,
      ),
    )
    dispatch({
      type: actionTypes.BASKET_ORDER_DETAILS_LOADED,
      orderId,
      orderDetails: immutableOrderDetails,
    })
  } catch (err) {
    logger.error({ message: 'Error loading order data', errors: [err] })
  }
}

export const orderConfirmationProductTracking = (trackingData) => (dispatch) => {
  dispatch({
    type: actionTypes.BASKET_PRODUCT_TRACKING,
    trackingData: { actionType: trackingData.eventName, trackingData },
  })
}

export const orderConfirmationUpdateOrderTracking = () => (dispatch, getState) => {
  const { basket, user } = getState()
  const orderId = basket.get('orderId')
  const basketOrderDetails = basket.get('orderDetails')
  const prices = basketOrderDetails.get('prices')
  const orderTotal = prices.get('total')
  const promoCode = prices.get('promoCode')
  const subscription = user.get('subscription')
  const subscriptionActive = subscription.get('state') === 'active'

  dispatch({
    type: actionTypes.ORDER_CONFIRMATION_EDITED_TRACKING,
    trackingData: {
      actionType: 'Order Edited',
      order_id: orderId,
      order_total: orderTotal,
      promo_code: promoCode,
      signup: false,
      subscription_active: subscriptionActive,
    },
  })
}
